import { render, staticRenderFns } from "./SellsyAcademySlide.vue?vue&type=template&id=08a5df72&scoped=true&"
import script from "./SellsyAcademySlide.vue?vue&type=script&lang=js&"
export * from "./SellsyAcademySlide.vue?vue&type=script&lang=js&"
import style0 from "./SellsyAcademySlide.vue?vue&type=style&index=0&id=08a5df72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5df72",
  null
  
)

export default component.exports